import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TopbarOrganism from '@/components/organisms/topbar-organism/TopbarOrganism.vue';
  import TableMolecule from '@/components/molecules/table-molecule/TableMolecule.vue';
  import { SearchbarModalOptions } from '@/shared/searchbarModalOptions';
  import { ref } from 'vue';

  const dataType = 'User';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersListView',
  setup(__props) {

  const getDateDaysAgo = (days: number): string => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date.toISOString();
  };

  const filterOptions = ref<SearchbarModalOptions[]>([
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(7)}`,
      'Last 7 days'
    ),
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(30)}`,
      'Last 30 days'
    ),
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(90)}`,
      'Last 90 days'
    ),
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(180)}`,
      'Last 6 months'
    ),
    new SearchbarModalOptions(
      `created_at:gte:${getDateDaysAgo(365)}`,
      'Last year'
    ),
  ]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TopbarOrganism, { title: "Users" }),
    _createVNode(TableMolecule, {
      dataType: dataType,
      filterOptions: filterOptions.value
    }, null, 8, ["filterOptions"])
  ]))
}
}

})